import React from "react";
import "./style/navbar.css";

const Navbar = () => {
  return <nav>ポケモン図鑑</nav>;
};

export default Navbar;
